import { Flex } from '@chakra-ui/core'
import { motion } from 'framer-motion'

const MotionFlex = motion.custom(Flex)

export default MotionFlex
